import { CheckboxMarkedIcon } from './CheckboxMarkedIcon';

/**
 * author: Google
 * id C3E50D88-07AB-491F-B21E-9AA11A1E5886
 * name checkbox-marked
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-marked.svg
 * tags
 * - Form 
 */
export const CheckBoxIcon = CheckboxMarkedIcon;
export default CheckBoxIcon